var data = {
	"body": "<path d=\"M8 211q0-14 10-24t24-10t24 10l452 452l445-445q10-10 24-10t24 10t10 24t-10 24L542 711q-10 10-24 10t-24-10L18 236q-2-2-3.5-4.5t-2.5-5l-2-5l-1.5-5L8 211z\" fill=\"currentColor\"/>",
	"width": 1024,
	"height": 896
};
exports.__esModule = true;
exports.default = data;
